// extracted by mini-css-extract-plugin
export default {"no-pad":"Notification__no-pad__ec8fca78f9a6ea68d172","noPad":"Notification__no-pad__ec8fca78f9a6ea68d172"};